import { EmoCart, EmoEye, EmoGift, EmoPin } from "@assets"

import { AuthButton } from "@/components/auth-button"

interface FeedHeroProps {
  stats: {
    events_this_weekend: number
    active_raffles: number
  }
  heroStats?: {
    total_users: number
    total_businesses: number
  }
}

const features = [
  { icon: EmoPin, label: "Eventos" },
  { icon: EmoGift, label: "Sorteos" },
  { icon: EmoEye, label: "Foro" },
  { icon: EmoCart, label: "Mercado" },
]

export function FeedHero({ stats, heroStats }: FeedHeroProps) {
  const proofItems: string[] = []
  if (heroStats?.total_users && heroStats.total_users > 0) {
    proofItems.push(
      `${heroStats.total_users.toLocaleString("es-ES")}+ argentinos`,
    )
  }
  if (stats.events_this_weekend > 0) {
    proofItems.push(
      `${stats.events_this_weekend} evento${stats.events_this_weekend === 1 ? "" : "s"} este finde`,
    )
  }
  if (stats.active_raffles > 0) {
    proofItems.push(
      `${stats.active_raffles} sorteo${stats.active_raffles === 1 ? "" : "s"} activo${stats.active_raffles === 1 ? "" : "s"}`,
    )
  }
  if (heroStats?.total_businesses && heroStats.total_businesses > 0) {
    proofItems.push(`${heroStats.total_businesses}+ negocios`)
  }

  return (
    <div className="relative mx-[15px] mt-[16px] overflow-hidden rounded-2xl border border-[#c2d4ff] md:mx-0 dark:border-[#2a2a2a]">
      {/* Dual radial glow — Argentina celeste top-left, Spain gold top-right */}
      <div
        className="absolute inset-0 hidden dark:block"
        style={{
          background: [
            "radial-gradient(ellipse at 20% -10%, #75AADB15 0%, transparent 55%)",
            "radial-gradient(ellipse at 80% -10%, #FCBF4915 0%, transparent 55%)",
            "#1E1E1E",
          ].join(", "),
        }}
      />
      <div
        className="absolute inset-0 block dark:hidden"
        style={{
          background: [
            "radial-gradient(ellipse at 20% -10%, #75AADB20 0%, transparent 55%)",
            "radial-gradient(ellipse at 80% -10%, #FCBF4920 0%, transparent 55%)",
            "#FFFFFF",
          ].join(", "),
        }}
      />

      {/* Top accent: Spain red → Argentina celeste */}
      <div
        className="absolute top-0 right-0 left-0 h-[2px]"
        style={{
          background:
            "linear-gradient(90deg, #C60B1E, #FCBF49, #75AADB, #FFFFFF)",
        }}
      />

      <div className="relative px-5 pt-7 pb-6">
        {/* Logo + tagline */}
        <div className="flex flex-col items-center">
          <img
            src="/icon_transparent.png"
            alt="CurrAr"
            className="mb-3 h-[52px] w-[52px] drop-shadow-lg"
          />
          <h2 className="text-foreground text-center text-[24px] leading-[30px] font-bold tracking-[-0.5px]">
            La comunidad de
            <br />
            <span className="text-primary dark:hidden">
              argentinos en Madrid
            </span>
            <span
              className="hidden dark:inline"
              style={{
                background: "linear-gradient(90deg, #75AADB, #FFFFFF)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              argentinos en Madrid
            </span>
          </h2>
        </div>

        <p className="text-muted-foreground mx-auto mt-2.5 max-w-[260px] text-center text-[14px] leading-[20px]">
          Conectá con argentinos de tu barrio
        </p>

        {/* Feature pills */}
        <div className="mt-5 flex items-center justify-center gap-[6px]">
          {features.map((f) => (
            <div
              key={f.label}
              className="flex items-center gap-1.5 rounded-[10px] border border-[#c2d4ff] bg-[#e9f2ff] px-2.5 py-[6px] dark:border-[#2a2a2a] dark:bg-[#161616]"
            >
              <img src={f.icon} alt="" className="h-[20px] w-[20px]" />
              <span className="text-foreground text-[11px] font-semibold tracking-[0.2px]">
                {f.label}
              </span>
            </div>
          ))}
        </div>

        {/* Social proof counters */}
        {proofItems.length > 0 && (
          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            {proofItems.map((item, i) => (
              <span key={i} className="flex items-center text-[12px]">
                {i > 0 && (
                  <span className="text-muted-foreground mr-2 text-[8px]">
                    ●
                  </span>
                )}
                <span className="text-muted-foreground font-medium">
                  {item}
                </span>
              </span>
            ))}
          </div>
        )}

        {/* CTA */}
        <div className="mt-5 flex justify-center">
          <AuthButton
            authAction="register"
            className="bg-primary h-[46px] w-full max-w-[280px] rounded-xl border-0 text-[15px] font-bold tracking-[0.3px] text-white shadow-[0_4px_20px_rgba(85,123,244,0.3)]"
          >
            Unite gratis
          </AuthButton>
        </div>
      </div>
    </div>
  )
}
